import { Typography } from '@mui/material';

type MainMenuItemErrorProps = {
    message?: string | undefined;
};

export const MainMenuItemError = ({ message }: MainMenuItemErrorProps) =>
    <Typography variant="h6" color="error" align="center">
        Neispravna navigacijska stavka!
        {message && `&nbsp;<strong>${message}</strong>`}
    </Typography>;
